class BillfoldService {
  constructor ($q, $http, ngAuthSettings) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }
  
  getBranchesByThirdId(thirdId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getOrderState(documentNumber, orderNumber) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2  + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES+
        '?terceroId=' + documentNumber +
        '&pedidoId=' + orderNumber,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getOrderStates(documentNumber, branchCode) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES +
        '?terceroId=' + documentNumber +
        '&sucursalCodigo=' + branchCode,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getOrderStatesBranches(documentNumber, branchCodes, fecha_ini, fecha_fin) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.ORDER.STATES2,
        data : {
          'documentoTercero' : documentNumber,
          'branchCode' : branchCodes,
          'fecha_ini' : fecha_ini,
          'fecha_fin' : fecha_fin
        },
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

BillfoldService.$inject = ['$q','$http', 'ngAuthSettings'];

export default BillfoldService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/reports/orders/orders.service.js
 **/